var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B5ADB6;}\r\n\t.st1{fill:#7A6E79;}\r\n\t.st2{fill:#685E67;}\r\n\t.st3{fill:#107295;}\r\n\t.st4{fill:#0D5F7F;}\r\n\t.st5{fill:#433F43;}\r\n\t.st6{fill:#64E0C4;}\r\n\t.st7{fill:#27D1B3;}\r\n\t.st8{fill:#64B9FC;}\r\n\t.st9{fill:#A3E440;}\r\n\t.st10{fill:#FCC16D;}\r\n\t.st11{fill:#FC5A95;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,14.1h-1.4V5H24c0.4,0,0.6,0.3,0.6,0.6v7.8C24.7,13.9,24.4,14.1,24,14.1L24,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,8.9h1.4V5H4.4C4,5,3.7,5.3,3.7,5.7v2.5C3.7,8.6,4,8.9,4.4,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,14.1h1.4v-3.8H4.4c-0.4,0-0.6,0.3-0.6,0.6v2.5C3.7,13.9,4,14.1,4.4,14.1L4.4,14.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,32H7.2c-1.1,0-1.9-0.9-1.9-1.9V1.9C5.2,0.9,6.1,0,7.2,0h14.1c1.1,0,1.9,0.9,1.9,1.9v28.1 C23.2,31.1,22.3,32,21.2,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.2,1.9v28.1c0,1.1-0.9,1.9-1.9,1.9H19c1.1,0,1.9-0.9,1.9-1.9V1.9C21,0.9,20.1,0,19,0h2.2 C22.3,0,23.2,0.9,23.2,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.6,1.9v28.1c0,0.2-0.1,0.3-0.3,0.3H7.2c-0.2,0-0.3-0.1-0.3-0.3V1.9c0-0.2,0.1-0.3,0.3-0.3h3.5 c0.1,0,0.3,0.1,0.3,0.2l0.4,0.9C11.5,3,11.7,3.2,12,3.2h4.4c0.3,0,0.5-0.2,0.6-0.4l0.4-0.9c0-0.1,0.2-0.2,0.3-0.2h3.5 C21.4,1.6,21.6,1.8,21.6,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.6,8.6v8.5h-5.9c-0.4,0-0.6-0.3-0.6-0.6V9.3c0-0.4,0.3-0.6,0.6-0.6L21.6,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.6,1.9v28.1c0,0.2-0.1,0.3-0.3,0.3h-1.8c0.2,0,0.3-0.1,0.3-0.3V1.9c0-0.2-0.1-0.3-0.3-0.3h1.8 C21.4,1.6,21.6,1.8,21.6,1.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.1,2.1h-1.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.3c0.3,0,0.5,0.2,0.5,0.5S14.3,2.1,14.1,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.6,2.1c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v0 C16.1,1.9,15.9,2.1,15.6,2.1L15.6,2.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.7,28.8h-5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5 C17.2,28.6,16.9,28.8,16.7,28.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.6,15.6H15.7c-0.4,0-0.6-0.3-0.6-0.6V7.7c0-0.4,0.3-0.6,0.6-0.6h11.9c0.4,0,0.6,0.3,0.6,0.6v7.2 C28.3,15.3,28,15.6,27.6,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.3,7.7v7.2c0,0.4-0.3,0.6-0.6,0.6h-1.7c0.4,0,0.6-0.3,0.6-0.6V7.7c0-0.4-0.3-0.6-0.6-0.6h1.7 C28,7.1,28.3,7.4,28.3,7.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.3,13.4c-0.1,0-0.2,0-0.3-0.1l-1.7-1.6c-0.1-0.1-0.1-0.2-0.1-0.3s0.1-0.3,0.1-0.3l1.7-1.6 c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-1.3,1.3l1.3,1.3c0.2,0.2,0.2,0.5,0,0.7C19.5,13.4,19.4,13.4,19.3,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24,13.4c-0.1,0-0.3-0.1-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.3-1.3l-1.3-1.3c-0.2-0.2-0.2-0.5,0-0.7 c0.2-0.2,0.5-0.2,0.7,0L26,11c0.1,0.1,0.1,0.2,0.1,0.3s-0.1,0.3-0.1,0.3l-1.7,1.6C24.3,13.4,24.1,13.4,24,13.4L24,13.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21,13.4c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.4-0.3-0.6l1.3-3.2c0.1-0.2,0.4-0.4,0.6-0.3 c0.2,0.1,0.4,0.4,0.3,0.6l-1.3,3.2C21.4,13.3,21.2,13.4,21,13.4L21,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.3,18.3c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v0C9.8,18.1,9.5,18.3,9.3,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M13.3,18.3h-2.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3c0.3,0,0.5,0.2,0.5,0.5S13.6,18.3,13.3,18.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M9.3,20.4c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v0C9.8,20.2,9.5,20.4,9.3,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.7,20.4h-6.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.6c0.3,0,0.5,0.2,0.5,0.5S17.9,20.4,17.7,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.3,22.4c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v0C9.8,22.2,9.5,22.4,9.3,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.1,22.4h-8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8c0.3,0,0.5,0.2,0.5,0.5 C19.6,22.2,19.4,22.4,19.1,22.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.3,24.5c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v0C9.8,24.3,9.5,24.5,9.3,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.1,24.5h-8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8c0.3,0,0.5,0.2,0.5,0.5 C19.6,24.3,19.4,24.5,19.1,24.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M13.1,15H9.3c-0.3,0-0.5-0.2-0.5-0.5S9,14,9.3,14h3.8c0.3,0,0.5,0.2,0.5,0.5S13.4,15,13.1,15L13.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M13.1,12.9H9.3c-0.3,0-0.5-0.2-0.5-0.5S9,12,9.3,12h3.8c0.3,0,0.5,0.2,0.5,0.5S13.4,12.9,13.1,12.9 L13.1,12.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,10.9H9.3c-0.3,0-0.5-0.2-0.5-0.5S9,9.9,9.3,9.9h3.8c0.3,0,0.5,0.2,0.5,0.5 C13.6,10.7,13.4,10.9,13.1,10.9L13.1,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,8.8H9.3C9,8.8,8.8,8.6,8.8,8.3S9,7.8,9.3,7.8h3.8c0.3,0,0.5,0.2,0.5,0.5C13.6,8.6,13.4,8.8,13.1,8.8 L13.1,8.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppDevelopment);
export default __webpack_public_path__ + "static/media/mobile-app-development.2e97d17a1770801ee1462395ad4a287b.svg";
export { ForwardRef as ReactComponent };